import { Route, BrowserRouter, Switch } from 'react-router-dom'

// Redux
import { Provider } from 'react-redux'
import store from './store/configureStore'

// Components
import WaitList from './Pages/WaitList'
import NotFoundPage from './Pages/NotFoundPage'
import RemoteWaitList from './Pages/RemoteWaitList'
import TermsOfService from './Pages/TermsOfService'

// Sentry
import * as Sentry from '@sentry/react'
import { CurrentUserProvider } from './Services/current-user.service'

function App() {
	return (
		<BrowserRouter>
			<Provider store={store}>
				<CurrentUserProvider>
					<Switch>
						<Route exact path="/waitlist/:waitlistId" component={WaitList} />
						<Route exact path="/remote-waitlist/:venueId" component={RemoteWaitList} />
						<Route exact path="/terms-service" component={TermsOfService} />
						<Route path="*" component={NotFoundPage} />
					</Switch>
				</CurrentUserProvider>
			</Provider>
		</BrowserRouter>
	)
}

export default Sentry.withProfiler(App)